import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { updateChapter } from '@modules/chapter';
import api from '@utils/axiosInstance';

function TextInput({ idx, text, el, type, setIsChanged }) {
    const chapterList = useSelector(state => state.chapter.chapterList);
    const organizationData = useSelector(state => state.organization.organizationData);
    const userToken = useSelector(state => state.organization.userToken);

    const dispatch = useDispatch();
    const { uuid, lang } = useParams();

    const [changedObj, setChangedObj] = useState({});
    const [content, setContent] = useState('');

    useEffect(() => {
        if (chapterList.length > 0) {
            setContent(chapterList[idx]?.[type]);
        }
    }, [chapterList, idx]);

    function handleChange(content) {
        setIsChanged(true);

        const newObj = {
            ...chapterList[idx],
            content: content
        };

        setChangedObj(newObj);
    }

    function fetchText(e) {
        e.preventDefault();
        setIsChanged(false);

        if (Object.keys(changedObj).length > 0) {
            // Redux 액션 디스패치
            dispatch(updateChapter(idx, { [type]: changedObj.content }));

            // API 호출
            const tmpChapList = [...chapterList];
            tmpChapList[idx] = {
                ...tmpChapList[idx],
                [type]: changedObj.content
            };

            saveChaptersToServer(tmpChapList);
        }
    }

    function saveChaptersToServer(chapArr) {
        console.log('saveChaptersToServer', chapArr);
        const formatted = chapArr.map(list => (
            {
                index: String(list.index),
                type: "seeker",
                start: list.start,
                label: list.label,
                thumbnail: list.thumbnail,
                desc: list.desc,
            }));

        api({
            method: 'post',
            url: '/chapter/aUpdate',
            data: {
                tk: userToken,
                uuid: uuid,
                ogc: organizationData.organization_code,
                lang: lang,
                chapter: formatted
            }
        })
            .then((response) => {
                console.log('edit data', response.data.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <div key={idx} className='box-editable-text' suppressContentEditableWarning={true} onBlur={e => fetchText(e)} style={{ width: type === 'label' ? '35%' : '60%' }}>
            <div
                className='editable-text'
                contentEditable={true}
                suppressContentEditableWarning={true}
                onInput={(e) => handleChange(e.currentTarget.textContent)}
            >
                {content}
            </div>
        </div>
    );
}

export default TextInput;